import { ApiResult, request, safeRequest } from '@synergy/api';

import { SearchInteractionType } from '../models/search-origin';

/**
 * Reports what became of a search result. Deliberately fire-and-forget: a failed
 * report costs a measurement, it must never cost the member their click.
 */
export class SearchInteractionApi {
    constructor(protected baseUrl: string) {}

    public report = (
        searchEventId: number,
        type: SearchInteractionType,
        productId: number,
        position?: number
    ): Promise<ApiResult<void>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/search-interactions`, { searchEventId, type, productId, position }),
            () => undefined
        );
}
